import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { useApi } from "../../hooks/useApi";
import Header from "../../components/Form/Header";
import Footer from "../../components/Form/Footer";
import Modal from "../../components/Modal/Modal";

const GerarPix = () => {
  const { token } = useParams(); // 👈 mudou de id para token
  const { fetchData } = useApi();
  const [pixCode, setPixCode] = useState("");
  const [valorTotal, setValorTotal] = useState(null);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const carregarPix = async () => {
      try {
        // ✅ Busca valor usando token criptografado
        const valor = await fetchData(`/PedidoSemLoginDelivery/GetValorPedido?token=${token}`);
        setValorTotal(valor);

        // Gera código Pix
        const pixResp = await fetchData(`/Pix?valor=${valor}`);
        setPixCode(pixResp);
      } catch (err) {
        console.error(err);
        setError("Erro ao gerar QR Code Pix.");
      }
    };

    carregarPix();
  }, [token, fetchData]);

  return (
    <>
      <Header urlBack={"/"} titulo="Pagamento via Pix" />
      <div style={{ textAlign: "center", padding: "20px" }}>
        {error && <Modal show={true} message={error} onClose={() => setError(null)} />}

        {valorTotal && (
          <p>Valor do pedido: <strong>R$ {Number(valorTotal).toFixed(2)}</strong></p>
        )}

        {pixCode ? (
          <>
            <h3>Escaneie o QR Code abaixo para pagar:</h3>
            <QRCodeCanvas value={pixCode} size={256} />
            <p style={{ wordBreak: "break-all", marginTop: "10px" }}>{pixCode}</p>

            <button
              onClick={() => {
                navigator.clipboard.writeText(pixCode);
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
              }}
              style={{
                marginTop: "15px",
                padding: "10px 20px",
                backgroundColor: "#4caf50",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Copiar Código Pix
            </button>

            {copied && (
              <p style={{ color: "green", fontWeight: "bold", marginTop: "10px" }}>
                ✅ Código copiado!
              </p>
            )}
          </>
        ) : (
          <p>Gerando QR Code Pix...</p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default GerarPix;